import { fetchAccountSuccess, setNewAccessToken, updateUrlAndVersion } from '../actions';
import { AccountMigrationStatus } from '../type/enums';
import { handleCurrentSession } from '../utils/amplify';
import api from './api';
import dayjs from 'dayjs'

export const accountApi = api.injectEndpoints({
    endpoints: builder => ({
        getAccount: builder.query({
            query: () => ({ url: '/account' }),
            async onQueryStarted(arg, { dispatch, getState, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
        
                    if (data.migrationStatus === AccountMigrationStatus.MIGRATED) {
                        const wasPreviouslyMigrating = getState().accountReducer.migrationStatus === AccountMigrationStatus.MIGRATING;
        
                        if (wasPreviouslyMigrating) {
                            const newToken = await handleCurrentSession({ forceRefresh: true });
                            await dispatch(setNewAccessToken(newToken));
                            dispatch(updateUrlAndVersion('/v2'));
                        }
                    }
        
                    const { cards, ...account } = data;
                    return dispatch(fetchAccountSuccess({ account, cards }));
                } catch (error) {
                    console.error('Error fetching account:', error);
                }
            },
        }),
        finalizeAccount: builder.mutation({
            query: () => ({ url: '/account/finalise', method: 'post' }),
        }),
        activateAccount: builder.mutation({
            query: ({ activationCode, dob }) => ({
                url: `/account/activate`,
                method: 'post',
                data: { code: activationCode, dob: dayjs(dob).format('YYYY-MM-DD') },
            }),
        }),
    }),
});

export const {
    useFinalizeAccountMutation,
    useActivateAccountMutation,
    useGetAccountQuery
} = accountApi;
